import axios from 'axios';
import config from '@/config';

const baseHeaders = {
  'Content-Type': 'application/json',
  'apollographql-client-name': 'com.odeko.orderahead-admin.web',
  'apollographql-client-version': process.env.VUE_APP_VERSION,
};

const securedAxiosInstance = axios.create({
  baseURL: config().apiUrl,
  withCredentials: false,
  headers: baseHeaders,
});

const plainAxiosInstance = axios.create({
  baseURL: config().apiUrl,
  withCredentials: false,
  headers: baseHeaders,
});

securedAxiosInstance.interceptors.request.use(config => {
  let authHeaders = {
    'Authorization': `Bearer ${localStorage.access}`
    // , 'X-Refresh-Token': localStorage.refresh
  };
  const method = config.method.toUpperCase();
  if (method !== 'OPTIONS' && method !== 'GET') {
    authHeaders['X-CSRF-TOKEN'] = localStorage.csrf;
  }
  config.headers = { ...config.headers, ...authHeaders };
  return config
});

securedAxiosInstance.interceptors.response.use(null, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    // If 401 by expired access cookie, we do a refresh request
    return plainAxiosInstance.post('/sessions/refresh-web', {}, { headers: { 'X-CSRF-TOKEN': localStorage.csrf } })
      .then(response => {
        localStorage.csrf = response.data.csrf;
        localStorage.access = response.data.access;
        localStorage.signedIn = true;
        // After another successfull refresh - repeat original request
        let retryConfig = error.response.config;
        retryConfig.headers["X-CSRF-TOKEN"] = localStorage.csrf;
        retryConfig.headers["Authorization"] = `Bearer ${localStorage.access}`;
        return plainAxiosInstance.request(retryConfig);
      }).catch(error => {
        delete localStorage.csrf;
        delete localStorage.access;
        delete localStorage.signedIn;
        // redirect to signin if refresh fails
        location.replace("/");
        return Promise.reject(error)
      })
  } else {
    return Promise.reject(error)
  }
});

export { securedAxiosInstance, plainAxiosInstance }
